import {setIsPWA} from '../state/slice/global';
import {dispatch} from '../state/store';
import log from './logger/log';
import {userBrowserService} from './userBrowserService';

const updatePWAStatus = () => {
    const isPWA = userBrowserService.getIsPWA();

    dispatch(setIsPWA(isPWA));

    log.debug(`appService: PWA status updated: isPWA: ${isPWA}`);
};

export default {
    updatePWAStatus,
};
